/* eslint-disable react-hooks/exhaustive-deps */
// Core
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

// Styles
import { AboutSection, AwardSetting, BannerStrip, HomepageWrapper, NewsMedia, NewsMediaItem, ProjectItem, Projects, Readmore, StatementItem, StatementItemWide, StatementSection, WinningCard, WinningTitle } from "./styles";

// Components
import Loader from "components/Loader";

// Others
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import LogoText from "assets/images/logo_txt.jpg";
import Logo from "assets/images/logo.jpg";

import About from "assets/images/about_home.jpg"
import { Grid, Label } from "assets/styles/globalStyles";
import { FontSizes, FontWeight } from "utils/enums";
import { colors } from "assets/styles/colors";
import { fetchData } from "utils/fetch";
import { restAPIs } from "utils/restAPIs";

import Slider from 'react-slick';
import { Avatar, Flex, Tooltip } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";

import AOS from "aos";
import { AwardLists } from "pages/AwardList/styles";
import Statement from "modals/Statement";
import ArticleView from "pages/AwardList/ArticleView";

const Homepage2: React.FC = () => {
    const { currentLang } = useSelector((store: any) => store.commonData);
    const navigate = useNavigate();
    const [pageLoading, setPageLoading] = useState(false);
    const { t } = useTranslation();
    const scrollRef = useRef<HTMLDivElement | null>(null);

    const [sliderRefAward, setSliderRefAwards] = useState<any>('')
    const [awards, setAwards] = useState([])
    const [awardPage, setAwardPage] = useState(1)
    const [awardPageTitle, setAwardPageTitle] = useState('')
    const [awardPageDesc, setAwardPageDesc] = useState('')
    const [awardLastPage, setAwardLastPage] = useState(false)

    const [articles, setArticles] = useState([])
    const [recentWinnings, setRecentWinnings] = useState<any>([])
    const [projects, setProjects] = useState<any>([])
    const [statements, setStatements] = useState<any>([])

    const [isStatementModalOpen, setIsStatementModalOpen] = useState(false);
    const [statementData, setStatementData] = useState<any>(null);
    const [isOpenArticle, setOpenArticle] = useState(false)
    const [article, setArticle] = useState<any>(null)
    const [quote, setQuote] = useState<any>('')
    const [quoteAuthor, setQuoteAuthor] = useState<any>('')


    const imageStyles = [
        // # Row 1
        { bottom: "60%", right: "4%" },

        // # Row 2
        { bottom: "42%", right: "4%" },
        { bottom: "42%", right: "10%" },

        //  Row 3
        { bottom: "24%", right: "4%" },
        { bottom: "24%", right: "10%" },
        { bottom: "24%", right: "16%" },
        { bottom: "24%", right: "22%" },

        // # Row 4
        { bottom: "6%", right: "4%" },
        { bottom: "6%", right: "10%" },
        { bottom: "6%", right: "16%" },
        { bottom: "6%", right: "22%" },
        { bottom: "6%", right: "28%" },
    ];

    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: false, // Ensures the animation runs only once
            easing: 'ease-in-out', // Easing function for animations
        });

        const handleScroll = () => {
            AOS.refresh();
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        fetchAwards()
        fetchArticles()
        fetchProjects()
    }, [currentLang])


    const fetchAwards = async () => {
        const res = await fetchData(restAPIs.awardsList(currentLang?.id, null, null, 1));
        setAwards(res.items)
        setAwardPageTitle(res.pageTitle)
        setAwardPageDesc(res.pageDesc)
        setAwardLastPage(res.isLastPage)
    }


    const fetchAwardsPaginate = async () => {
        const res = await fetchData(restAPIs.awardsList(currentLang?.id, '', '', awardPage));
        let awardsLis = awards
        setAwards(awardsLis.concat(res.items))
    }

    const slickPrevAward = () => {
        sliderRefAward.slickPrev();
    }

    const slickNextAward = () => {
        sliderRefAward.slickNext();
        if (!awardLastPage) {
            let currenPage = awardPage + 1
            setAwardPage(currenPage)
            fetchAwardsPaginate()
        }
    }

    const settingsAwards = {
        dots: false,
        autoplay: false,
        infinite: false,
        slidesToShow: 7,
        slidesToScroll: 7,
        arrows: false,
        // afterChange: onSliderArticleChange,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {

                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                }
            }
        ]
    };

    const fetchArticles = async () => {
        const currentYear = new Date().getFullYear();
        const res = await fetchData(restAPIs.awardsList(currentLang?.id, null, currentYear, 1));
        setArticles(res.articles)
        setRecentWinnings(res.items)
        setStatements(res.statements)
        setQuoteAuthor(res.quoteAuthor)
        setQuote(res.quote)
    }

    const fetchProjects = async () => {
        const res = await fetchData(restAPIs.projectsList(currentLang?.id));
        setProjects(res.projects)
    }

    const handleStatementMore = (item: any) => {
        setStatementData(item)
        setIsStatementModalOpen(true)
    }


    const handleOpenArticle = (item: any) => {
        setArticle(item)
        setOpenArticle(true)
    }


    const handleBook = (bookId: any) => {
        navigate(`/book/${bookId}`)
    }

    const videos = Array.from({ length: 16 }, (_, index) => require(`assets/videos/${index + 1}.mp4`));


    if (pageLoading) return <Loader />;

    return (
        <>
            <HomepageWrapper ref={scrollRef} >
                {/* Hero Banner */}

                <div style={{
                    position: 'relative',
                    width: '100%',
                    height: '90vh',
                    overflow: 'hidden',
                    marginTop: '60px',
                    padding: '40px',
                    display: 'flex',
                    alignItems: 'end',
                    paddingLeft: '40px',
                    textAlign: 'center',
                }}>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            zIndex: -1
                        }}
                    >
                        <source src={videos[Math.floor(Math.random() * videos.length)]} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                    <motion.h1
                        className="fade-up"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 2 }}
                        style={{
                            color: '#fff',
                            padding: '20px',
                            backdropFilter: 'blur(3px)',
                            borderRadius: '10px',
                            background: '#00000052'
                        }}
                    >
                        <motion.span
                            initial={{ width: 0 }}
                            animate={{ width: "100%" }}
                            transition={{ duration: 4, ease: "easeInOut" }}
                            style={{
                                display: "inline-block",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                animation: "blink 0.5s step-end infinite alternate",
                            }}
                            className="__quote_2202"
                        >
                            <div dangerouslySetInnerHTML={{ __html: quote }}></div>
                            <span style={{ display: 'flex', justifyContent: 'flex-end', fontSize: '17px', marginTop: '10px' }}>-{quoteAuthor}</span>
                        </motion.span>
                    </motion.h1>

                    <div className="__hideout" style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }}>
                        {recentWinnings &&
                            recentWinnings.slice(0, imageStyles.length).map((item: any, index: any) => (
                                <motion.div
                                    key={index}
                                    initial={{
                                        opacity: 0,
                                        x: Math.cos((index / 10) * 2 * Math.PI) * 300, // Circular motion effect
                                        y: Math.sin((index / 10) * 2 * Math.PI) * 300,
                                        scale: 0.5,
                                    }}
                                    animate={{
                                        opacity: 1,
                                        x: 0,
                                        y: 0,
                                        scale: 1,
                                    }}
                                    transition={{
                                        duration: 1,
                                        delay: index * 0.2, // Staggered effect
                                        ease: "easeOut",
                                    }}
                                    onAnimationComplete={(definition) => {
                                        const element: any = document.querySelector(`.__hsn-${index}`);
                                        if (element) {
                                            element.style.position = "initial";
                                        }
                                    }}
                                    className={`__hsn __hsn-${index}`}
                                    style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        left: 0,
                                        top: 0
                                    }}

                                >
                                    <img
                                        onClick={() => handleBook(item?.bookId)}
                                        src={item?.coverImage}
                                        className={
                                            index === 4
                                                ? "absolute __image_size __ninesixeight1"
                                                : index === imageStyles.length - 1
                                                    ? "absolute __image_size __ninesixeight2"
                                                    : "absolute __image_size"
                                        }
                                        style={{
                                            position: "absolute",
                                            ...imageStyles[index], // Keeps images in their final positions
                                        }}
                                        alt=""
                                    />
                                </motion.div>
                            ))}
                    </div>
                </div>

                {/* Strip Section */}
                <BannerStrip className={currentLang?.lang === "ar" ? "rtl" : "ltr"}>
                    <h2 data-aos="fade-left" className="fade-left">{t('prestigious_award')}</h2>
                    <button data-aos="fade-right" className="fade-right" onClick={() => navigate('/award-info')}>{t('about_award')}</button>
                    <img src={LogoText} alt="logoText" />
                </BannerStrip>

                <div className={currentLang?.lang === "ar" ? "container rtl" : "container ltr"}>
                    <div className="row">
                        <AboutSection  >
                            <div>
                                <Label data-aos="fade-right" className="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={30} marginBottom={30}>{awardPageTitle}</Label>
                                <p data-aos="fade-right" className='mb-5' style={{ textAlign: 'justify', fontSize: '15px', marginBottom: '60px', whiteSpace: 'pre-line' }}>{awardPageDesc}</p>
                                <button className="fade-left" data-aos="fade-left" onClick={() => navigate('/award-info')}>{t('more_info')}</button>
                            </div>
                            <div >
                                <img src={About} alt="" className="fade-right" data-aos="fade-right" style={{
                                    width: '100%',
                                    minHeight: '400px',
                                    maxHeight: '500px',
                                    objectFit: 'contain'
                                }} />
                            </div>
                        </AboutSection>
                    </div>
                </div>


                <WinningTitle className={currentLang?.lang === "ar" ? "rtl" : "ltr"} >
                    <section className="container">
                        <Label data-aos="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={30} marginBottom={100} style={{ textAlign: 'center' }}>{t('recent_titles')}</Label>
                        <div className="row">
                            <div className="col-md-11">
                                <AwardLists>
                                    {recentWinnings && recentWinnings.map((item: any, i: any) => (
                                        <div
                                            data-aos="fade-left"
                                            className="mb-5"
                                            style={{ width: '100%' }}
                                            key={i}
                                            data-aos-delay={i * 200}
                                        >
                                            <WinningCard onClick={() => handleBook(item?.bookId)}>
                                                <div className="book">
                                                    <div className="cover" style={{ backgroundImage: `url(${item.coverImage})` }}></div>
                                                    <div className="__category">{item.categoryName}</div>
                                                </div>

                                                <div className="__content">
                                                    <Tooltip title={item.bookName}>
                                                        <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h2} marginBottom={15}>
                                                            {item.bookName}
                                                        </Label>
                                                    </Tooltip>
                                                    <Tooltip title={`${item.authorName}`}>
                                                        <p className="__author">{item.authorName}</p>
                                                    </Tooltip>
                                                    <Tooltip title={` ${item.categoryName}`}>
                                                        <p>{item.categoryName}</p>
                                                    </Tooltip>
                                                    <p style={{ color: colors.darkPrimary }}>{item.year}</p>
                                                </div>
                                            </WinningCard>
                                        </div>
                                    ))}
                                </AwardLists>
                            </div>
                        </div>
                    </section>
                    <div className="container">
                        <div className="row justify-content-center mt-5">
                            <Flex justify="center" className="mb-5">
                                <Readmore onClick={() => navigate('/awards')}>{t('more_info')}</Readmore>
                            </Flex>
                        </div>
                    </div>
                </WinningTitle>


                <StatementSection className={currentLang?.lang === "ar" ? "rtl" : "ltr"} style={{ backgroundColor: '#c5950424' }}>
                    {/* <Label data-aos="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={30} marginBottom={60} style={{ textAlign: 'center' }}>{t('statements')}</Label> */}
                    <div className="container">

                        {statements && <div className="row">
                            <div className="col-md-12">
                                <StatementItemWide data-aos="fade-left" data-aos-delay={200} >
                                    <img src={statements[0]?.picture} alt="" className="__left" />
                                    <div className="____content">
                                        <img src={statements[0]?.personPicture} alt="" style={{ height: '160px', minHeight: '160px', width: '160px', borderRadius: '5px', objectFit: 'cover' }} />
                                        <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h1} marginBottom={10} >
                                            {statements[0]?.name}
                                        </Label>

                                        <Label fontWeight={FontWeight.bold} color={colors.secondary} fontSize={FontSizes.h3} marginBottom={20}>
                                            <span style={{ color: colors.secondary }} dangerouslySetInnerHTML={{ __html: statements[0]?.subtitle }}></span>
                                        </Label>

                                        <p style={{ fontSize: '19px', marginBottom: '15px' }}>{statements[0]?.subbody}</p>
                                        <button onClick={() => handleStatementMore(statements[0])}>{t('more')}</button>
                                    </div>
                                </StatementItemWide>
                            </div>
                            <div className="col-md-6">
                                <StatementItem data-aos="fade-left" data-aos-delay={2 * 200} >
                                    <img src={statements[1]?.picture} alt="" className="__left" style={{ paddingTop: '30px' }} />
                                    <img src={statements[1]?.personPicture} alt="" className="__left__absolute" />
                                    <div className="____content">
                                        <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h3} marginBottom={3} >
                                            {statements[1]?.name}
                                        </Label>

                                        <Label fontWeight={FontWeight.bold} color={colors.secondary} fontSize={FontSizes.h6} marginBottom={10}>
                                            <span style={{ color: colors.secondary }} dangerouslySetInnerHTML={{ __html: statements[1]?.subtitle }}></span>
                                        </Label>
                                        <p>{statements[1]?.subbody}</p>
                                        <button onClick={() => handleStatementMore(statements[1])}>More</button>
                                    </div>
                                </StatementItem>
                            </div>

                            <div className="col-md-6">
                                <StatementItem data-aos="fade-left" data-aos-delay={3 * 200} >
                                    <img src={statements[2]?.picture} alt="" className="__left" style={{ paddingTop: '30px' }} />
                                    <img src={statements[2]?.personPicture} alt="" className="__left__absolute" />
                                    <div className="____content">
                                        <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h3} marginBottom={3} >
                                            {statements[2]?.name}
                                        </Label>

                                        <Label fontWeight={FontWeight.bold} color={colors.secondary} fontSize={FontSizes.h6} marginBottom={10}>
                                            <span style={{ color: colors.secondary }} dangerouslySetInnerHTML={{ __html: statements[2]?.subtitle }}></span>
                                        </Label>

                                        <p>{statements[2]?.subbody}</p>
                                        <button onClick={() => handleStatementMore(statements[2])}>More</button>
                                    </div>
                                </StatementItem>
                            </div>
                        </div>
                        }
                    </div>
                </StatementSection>

                <AwardSetting className={currentLang?.lang === "ar" ? "rtl" : "ltr"} >
                    <div style={{ padding: '60px 0' }} className='mb-2'>
                        <div className='container' style={{ position: 'relative' }}>
                            <Label data-aos="fade-right" className="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={30} marginBottom={50} style={{ textAlign: 'center' }}>{t('award_timeline')}</Label>
                            <div className='__award_lists' data-aos="fade-right">
                                <button className="__award_button" onClick={() => slickPrevAward()} >
                                    <ArrowLeftOutlined />
                                </button>
                                <div style={{ width: 'calc(100% - 86px)', zIndex: 1 }}>
                                    <Slider {...settingsAwards} ref={c => setSliderRefAwards(c)}>
                                        {awards && awards.map((item: any, i) => {
                                            return (
                                                i % 2 == 0 ? <div className='__single_award' key={i}>
                                                    <Avatar alt={item.authorName} src={item.authorImage} />
                                                    <h1>{item.authorName}</h1>
                                                    <div className='__round'></div>
                                                    <div className='__dashed'></div>
                                                    <div className='__year'>{item.year}</div>
                                                    <div style={{ position: 'relative' }}>
                                                        <img className='imgss imageLoader' src={item.coverImage} alt={item.bookName} />
                                                        <span className='__category'>{item.categoryName}</span>
                                                    </div>
                                                </div> :
                                                    <div className='__single_award' key={i}>
                                                        <div style={{ position: 'relative' }}>
                                                            <img className='imgss imageLoader' src={item.coverImage} alt={item.bookName} />
                                                            <span className='__category_bot'>{item.categoryName}</span>
                                                        </div>
                                                        <div className='__year'>{item.year}</div>
                                                        <div className='__dashed'></div>
                                                        <div className='__round'></div>
                                                        <h1>{item.authorName}</h1>
                                                        <Avatar alt={item.authorName} src={item.authorImage} />
                                                    </div>
                                            )
                                        })}
                                    </Slider>
                                </div>
                                <button className="__award_button" onClick={() => slickNextAward()} >
                                    <ArrowRightOutlined />
                                </button>
                                <div className='__line'></div>
                            </div>
                        </div>

                        <div className="container">
                            <div className="row justify-content-center mt-5">
                                <Flex justify="center" className="mt-5">
                                    <Readmore onClick={() => navigate('/awards')}>{t('more_info')}</Readmore>
                                </Flex>
                            </div>
                        </div>
                    </div>
                </AwardSetting>

                <Projects className={currentLang?.lang === "ar" ? "rtl" : "ltr"} >
                    <div className="container">
                        <Label data-aos="fade-right" className="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={30} marginBottom={70} style={{ textAlign: 'center' }}>{t('projects')}</Label>
                        <Grid data-aos="fade-right" col={2} gap={30} >
                            {projects && projects.map((item: any, i: any) => {
                                return (
                                    <ProjectItem data-aos="fade-left" data-aos-delay={2 * 200} >
                                        <img src={item?.picture} alt="" className="__left" />
                                        <img src={item?.personPicture} alt="" className={currentLang?.lang === "ar" ? "rtl __left__absolute" : "ltr __left__absolute"} />
                                        <div className="____content">
                                            <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h3} marginBottom={3} >
                                                {item?.name}
                                            </Label>

                                            <Label fontWeight={FontWeight.bold} color={colors.secondary} fontSize={FontSizes.h6} marginBottom={10}>
                                                <span style={{ color: colors.secondary }} dangerouslySetInnerHTML={{ __html: item?.subtitle }}></span>
                                            </Label>
                                            <p>{item?.subbody}</p>
                                            <button onClick={() => handleStatementMore(item)}>More</button>
                                        </div>
                                    </ProjectItem>
                                );
                            })}
                        </Grid>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center mt-5">
                            <Flex justify="center" className="mt-5">
                                <Readmore onClick={() => navigate('/projects')}>{t('more_info')}</Readmore>
                            </Flex>
                        </div>
                    </div>
                </Projects>

                <NewsMedia className={currentLang?.lang === "ar" ? "rtl" : "ltr"} >
                    <div className='container'>
                        <Label data-aos="fade-right" className="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={30} marginBottom={70} style={{ textAlign: 'center' }}>{t('news_media')}</Label>
                        <div className='row justify-content-center' style={{ gap: '30px' }} data-aos="fade-right">
                            {articles && articles.map((item: any, i) => {
                                if (i < 3) {
                                    return (
                                        <motion.div
                                            className='col-md-3'
                                            initial={{ opacity: 0, y: 50 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.8, delay: 0.2 }}
                                            key={i}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleOpenArticle(item)}
                                            data-aos="fade-right"
                                            data-aos-delay={i * 200}
                                        >
                                            <NewsMediaItem>
                                                <img src={Logo} alt="" width={100} />
                                                <img src={LogoText} alt="" height={40} />
                                                <h1>{item.name}</h1>
                                                <p>{item.stripedBody}</p>
                                            </NewsMediaItem>
                                        </motion.div>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center mt-5">
                            <Flex justify="center" className="mt-5">
                                <Readmore onClick={() => navigate('/articles')}>{t('more_info')}</Readmore>
                            </Flex>
                        </div>
                    </div>
                </NewsMedia>
            </HomepageWrapper>

            <Statement
                open={isStatementModalOpen}
                onClose={() => setIsStatementModalOpen(false)}
                data={statementData}
            />

            <ArticleView
                open={isOpenArticle}
                onClose={() => setOpenArticle(false)}
                data={article}
            />

        </>
    );
};

export default Homepage2;